'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessagesUtk = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessagesUtk = exports.getMessagesUtk = (0, _getIn2.default)(['prospectUtks', 'messagesUtk']);


//////////////////
// WEBPACK FOOTER
// ./js/selectors/prospectUtkSelectors.js
// module id = 335
// module chunks = 2 3